import { render, staticRenderFns } from "./invoiceListDetailPurchase.vue?vue&type=template&id=09888ee0&scoped=true"
import script from "./invoiceListDetailPurchase.vue?vue&type=script&lang=js"
export * from "./invoiceListDetailPurchase.vue?vue&type=script&lang=js"
import style0 from "./invoiceListDetailPurchase.vue?vue&type=style&index=0&id=09888ee0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09888ee0",
  null
  
)

export default component.exports